
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    import rapidas from './pregunta-responder-predefinidas.vue';
    import { RespuestaPredefinida } from '@/__env/lib/Preguntas/RespuestaPredefinida';
import { Wait } from '@/__env/ext';
import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            rapidas,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Pregunta: Pregunta;
        @Prop()
        public Respuesta: string;
        public get RespuestaAEnviar(): string
        {
            return 'Hola ' + this.Pregunta.Usuario.Nickname + '. ' + this.Respuesta + ' Saludos.';
        }

        public Estado: string = 'ok';
        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {
            this.$emit( 'aplicando', this.Abierto );
        }

        async Abrir()
        {
            this.$emit( 'aplicando', this.Abierto );
            await Wait( 200 );
            this.Abierto = true;
        }


        async Enviar()
        {
            this.Estado = 'cargando';
            await Wait( 100 );
            let e = await this.Pregunta.Responder( this.RespuestaAEnviar );
            if ( e )
            {
                if ( e == "ya-respondida" )
                {
                    Utiles.Notificaciones.Error( 'Pregunta respondida por otro usuario' );
                }
                this.$emit( 'aplicado', true );
                this.Abierto = false;
            } else
            {
                await Wait( 100 );
                this.Estado = 'ok';
                Utiles.Notificaciones.Error( 'Error al responder' );
            }


        }

    }
